import React from 'react';
import DataGrid, {
    Column,
    MasterDetail,
    Pager,
    Paging,
    FilterRow,
    Selection,      
    Toolbar,        
    Item
} from 'devextreme-react/data-grid';
import LoadPanel from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';   // ← neu
import defaultUser from '../../utils/default-user';
import auditjobs from '../auditjobs/auditjobs.js';
//console.log(defaultUser.client)
//const jsonUrl = 'https://audit-pro.net/api/getAuditsDone.php?clientId=' + defaultUser.client;

class Auditdone extends React.Component {
    constructor(props) {
        super(props);
        this.dataGridRef = React.createRef();
        this.downloadAllPdfs = this.downloadAllPdfs.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);

        this.state = {
            selectedCount: 0,
            isLoading: false,           // ← für Loading-Indikator
        };
    }

    dataGridRef = React.createRef();

    onSelectionChanged(e) {
        const count = e.selectedRowKeys ? e.selectedRowKeys.length : 0;
        this.setState({ selectedCount: count });
    }
    async downloadAllPdfs() {
        const ref = this.dataGridRef.current;

        if (!ref) {
            return;
        }

        // Korrekte Art, die Instanz in DevExtreme React zu holen
        const instance = ref.instance ? ref.instance() : ref.getInstance?.();

        if (!instance || typeof instance.getSelectedRowKeys !== 'function') {
            return;
        }

        const selectedKeys = instance.getSelectedRowKeys();

        if (!selectedKeys || selectedKeys.length === 0) {
            return;
        }

        const result = await confirm(
            `<p><strong>PDF-Berichte von ${selectedKeys.length} Audit(s) herunterladen?</strong></p>
            <p>Es wird eine ZIP-Datei mit allen verfügbaren Prüfberichten erstellt.</p>
            <p style="font-size:0.80em; margin-top:10px;">
                Je nach Anzahl der ausgewählten Audits und Größe der PDFs kann dieser Vorgang<br/> 
                systemseitig länger dauern oder in Einzelfällen nicht erfolgreich abgeschlossen werden.
            </p>`,
            'PDF-Download bestätigen'
        );

        if (!result) {
            return; 
        }
        // Loading aktivieren
        this.setState({ isLoading: true });

        try {
            const response = await fetch('https://dgs.it-tn.de/api/downloadAuditPdf.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ auditIds: selectedKeys })
            });

            if (!response.ok) {
                alert('Fehler beim Erstellen der ZIP-Datei.');
                return;
            }

            // Prüfen, ob JSON-Fehlermeldung kommt
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                const errorData = await response.json();
                alert(errorData.message || 'Es konnten keine PDF-Berichte heruntergeladen werden.');
                return;
            }

            // ZIP herunterladen
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `Audits_PDFs_${new Date().toISOString().slice(0, 10)}.zip`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            console.error(error);
            alert('Download fehlgeschlagen. Bitte versuche es später erneut.');
        } finally {
            // Loading immer deaktivieren (auch bei Fehler)
            this.setState({ isLoading: false });
        }
    }

    render() {
        const jsonUrl = 'https://dgs.it-tn.de/api/getAuditsDone.php?clientId=' + defaultUser.client;
        const isButtonDisabled = this.state.selectedCount === 0;
        return (
            <><React.Fragment>
                <h2 className={'content-block'}>Audits durchgef&uuml;hrt</h2>
                <p className={'content-block'} style={{ fontSize: 12 }}><strong>Angezeigt sind die durchgef&uuml;hrten Audits der letzten 180 Tage.<br />
                    S&auml;mtliche durchgef&uuml;hrte Audits sind &uuml;ber Standorte/Allgemein zu jedem Standort verf&uuml;gbar.</strong></p>
                <DataGrid
                    ref={this.dataGridRef}
                    dataSource={jsonUrl}
                    showBorders={true}
                    showColumnLines={true}
                    //defaultFocusedRowIndex={0}
                    columnAutoWidth={true}
                    columnHidingEnabled={true}
                    onCellPrepared={this.onCellPrepared}
                    noDataText={'Keine Daten'}
                    keyExpr="id"
                    onSelectionChanged={this.onSelectionChanged}
                >
                    <Selection mode="multiple" />

                    <Toolbar>
                        <Item location="after">
                            <button
                                onClick={this.downloadAllPdfs}
                                className="dx-button dx-button-success dx-button-mode-contained"
                                disabled={isButtonDisabled || this.state.isLoading}
                                style={{ marginRight: 8 }}
                            >
                                {this.state.isLoading 
                                    ? 'ZIP wird erstellt...' 
                                    : 'Prüfberichte der ausgewählten Audits herunterladen'
                                }
                            </button>
                        </Item>
                    </Toolbar>

                    <Paging defaultPageSize={15} />
                    <Pager showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true}
                        //infoText={'Seite {0} von {1} ({2} Zeilen)'}
                    />
                    <FilterRow visible={true} />
                    <Column
                        dataField={'rowId'}
                        width={90}
                        caption={'#'}
                        hidingPriority={1} />
                    <Column
                        dataField={'company'}
                        caption={'Standort'}
                        hidingPriority={7} />
                    <Column
                        dataField={'street'}
                        caption={'Stra\u00dfe'}
                        hidingPriority={4} />
                    <Column
                        dataField={'zipcode'}
                        caption={'PLZ'}
                        hidingPriority={2} />
                    <Column
                        dataField={'city'}
                        caption={'Ort'}
                        hidingPriority={3} />
                    <Column
                        dataField={'objectJobs'}
                        caption={'Audits'}
                        hidingPriority={6} />
                    <Column
                        dataField={'displayDate'}
                        caption={'Plandatum'}
                        hidingPriority={5} />
                    <Column
                        dataField={'dateDone'}
                        caption={'Auditdatum'}
                        hidingPriority={7} />
                    <MasterDetail
                        enabled={true}
                        component={auditjobs}
                    />
                </DataGrid>
                {/* Loading Panel */}
                <LoadPanel
                    visible={this.state.isLoading}
                    showIndicator={true}
                    shading={true}
                    shadingColor="rgba(0,0,0,0.4)"
                    message="ZIP-Datei wird erstellt..."
                    position={{ of: 'body' }}
                />
            </React.Fragment>
                <React.Fragment>
                    <p className={'content-block'} style={{ fontSize: 10 }}><strong>Legende</strong><br /> AS = Arbeitssicherheit<br />OF = Ortsfeste elektrische Anlagen<br />OV = Ortsver&auml;nderliche elektrische Betriebsmittel<br />SB = Sicherheitsbeleuchtung</p>
                </React.Fragment></>
        );
    }
    onCellPrepared = (e) => {
        if (e.rowType === "data" && e.column.dataField === "company") {
            const useable = e.data.useable;
            const clientDone = e.data.ocj_client_done;
            e.cellElement.style.color = clientDone < 0 ? "red" : "undefined"; 
        }
    }
}
export default Auditdone;
